/** The API takes line numbers as JSON numbers; the form values were already validated as decimal strings. */
export function toCreditLineInput(line) {
    return {
        productTreeId: line.productTreeId,
        quantity: Number(line.quantity),
        unitPrice: Number(line.unitPrice),
        percentageOff: Number(line.percentageOff),
        customerPaid: Number(line.customerPaid),
    };
}
//# sourceMappingURL=to-credit-line-input.js.map